module.exports = __webpack_public_path__ + "images/product-badges/product-badge-reach-246a90665ae2aa9f51f691145d74bd8e.webp";